import { render, staticRenderFns } from "./userActionItemDetail.vue?vue&type=template&id=52a9680e&scoped=true&"
import script from "./userActionItemDetail.vue?vue&type=script&lang=js&"
export * from "./userActionItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./userActionItemDetail.vue?vue&type=style&index=0&id=52a9680e&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9680e",
  null
  
)

export default component.exports